import { stringSearch } from '@luminovo/design-system';
import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to the builder; without `templateId` it opens a new template, as this page did.
export const Route = createFileRoute('/_authenticated/templates/quotation/edit')({
    // Only redirects: the builder checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ templateId: 'optional' }),
    beforeLoad: ({ search }) => {
        throw redirect({
            to: '/templates/quotation/builder/{-$templateId}',
            params: { templateId: search.templateId },
            replace: true,
        });
    },
});
